import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
const paysList = require('../../../../assets/jsons/countries.json');
import { models } from '../modele/modele-form';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from 'src/app/services/utils.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-sante',
  templateUrl: './sante.component.html',
  styleUrls: ['./sante.component.scss']
})
export class SanteComponent implements OnInit {

  // Navigation et état
  currentStep = 0;
  totalSteps = 5; // accueil + 2 étapes + récapitulatif
  selectedOption: string = ''; // Particulier ou Entreprise
  
  // Formulaire principal
  simulationSanteForm: FormGroup;
  
  // États de l'interface
  loader: boolean = false;
  sendingRequest: boolean = false;
  isFocus: boolean = false;
  hasPhoneError: boolean = false;
  
  // Données
  listPays = paysList;
  listTypeSexe = [{name:'Féminin',value:'Feminin'},{name:'Masculin',value:'Masculin'}];
  listTauxCouverture = [{name:'70%',value:'70%'},{name:'80%',value:'80%'},{name:'90%',value:'90%'},{name:'100%',value:'100%'}];
  listTerritorialite = [{name:'Afrique',value:'Afrique'},{name:'Monde entier',value:'Monde entier'}];
  listGaranties = [
    {name:'Consultation générale & spécialiste',value:'Consultation générale & spécialiste'},
    {name:'Pharmacie',value:'Pharmacie'},
    {name:'Hospitalisation',value:'Hospitalisation'},
    {name:'Maternité',value:'Maternité'},
    {name:'Dentisterie',value:'Dentisterie'},
    {name:'Optique',value:'Optique'},
    {name:'Transport',value:'Transport'}
  ];
  listEvacuation = [{name:'Oui',value:'oui'},{name:'Non',value:'non'}];
  
  // Configuration
  newDate = new Date();
  emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  // Références
  numeroSous: string;
  refPro: string;
  
  // Informations de la page
  slideData;
  lien = "";
  informations;
  title = "";

  // Document médical
  nomFile: string = "";
  noImage: string = "assets/images/upload.png";
  pieceJointe: FormGroup;
  downloadIcon = "assets/fileDownload/file.png";
  downloadFile: boolean = true;
  typeProduitList: any = {
    questionnaireUrl: '/assets/fileDownload/questionnaire_sante.pdf'
  };
  currentFiliale = JSON.parse(localStorage.getItem('currentFiliale'));


   // ===== AJOUT POUR AUTOSAVE =====
  private autoSaveSubject$ = new Subject<any>();
  private autoSaveSubscription: Subscription;
  private lastSavedData: string = ''; // Pour comparer les données
  // ================================


  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private utilsService: UtilsService,
    private rechercheService: SubscriptionService
  ) {
    // Initialisation des références
    let time = new Date().getTime();
    let pro = new Date().getTime() + 123890989;
    this.numeroSous = "SN" + time + "SC";
    this.refPro = "SN" + pro + "PR";

    // @ts-ignore
    let lienBrute: String = this.route.snapshot._routerState.url;
    this.lien = lienBrute.substring(1, lienBrute.length);
    this.informations = models[this.lien];
        
    localStorage.setItem('sectionShown', this.lien);
    this.slideData = [{
      title: this.informations.title,
      subTitle: this.informations.subTitle,
      description: this.informations.description,
      img: this.informations.imgBackground,
      type: this.informations.type,
      imgIcon: this.informations.imgIcon
    }]; 
  }

  ngOnInit() {
    this.initializeForm();
    this.setupAutoSave();
    this.listTerritorialite.unshift({name: this.currentFiliale?.pays, value: this.currentFiliale?.pays});
  }

// 2. Modifier l'initialisation du formulaire pour mieux gérer les garanties
initializeForm() {
  this.simulationSanteForm = this.fb.group({
    // Informations communes
    email: new FormControl('', [Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])]),
    telephone: ['', Validators.required],
    adresse: ['', Validators.required],
    
    // Informations spécifiques Particulier
    nom: [''],
    prenom: [''],
    dateNaiss: [''],
    conjoint: [''],
    assurePincipale: [''],
    enfant: [''],
    enfantMajeur: [''],
    effectif: [''],
    
    // Informations spécifiques Entreprise
    nomEntreprise: [''],
    name: [''],
    service: [''],
    fonction: [''],
    autres: [''],
    
    // Choix communs
    taux: ['', Validators.required],
    territorialite: ['', Validators.required],
    type: [[]], // ← CORRIGÉ : Initialiser comme array pour les checkboxes multiples
    evacuation: ['', Validators.required]
  });

  // FormGroup séparé pour le document médical
  this.pieceJointe = new FormGroup({
    file: new FormControl('')
  });
}

// 3. Ajouter une méthode pour gérer les garanties multiples
toggleGarantie(garantie: string) {
  const currentGaranties = this.simulationSanteForm.get('type')?.value || [];
  const index = currentGaranties.indexOf(garantie);
  
  if (index > -1) {
    // Retirer la garantie si elle est déjà sélectionnée
    currentGaranties.splice(index, 1);
  } else {
    // Ajouter la garantie si elle n'est pas sélectionnée
    currentGaranties.push(garantie);
  }
  
  this.simulationSanteForm.get('type')?.setValue(currentGaranties);
}

// 4. Vérifier si une garantie est sélectionnée
isGarantieSelected(garantie: string): boolean {
  const currentGaranties = this.simulationSanteForm.get('type')?.value || [];
  return currentGaranties.includes(garantie);
}



  checkNumberValue(){
    let value = Number(this.simulationSanteForm.get('enfant').value) + Number(this.simulationSanteForm.get('enfantMajeur').value) + Number(this.simulationSanteForm.get('assurePincipale').value) + Number(this.simulationSanteForm.get('conjoint').value);
    this.simulationSanteForm.get("effectif").setValue(value);
    if(isNaN(value)){
      this.simulationSanteForm.get('effectif').setValue(0);
    }
  }

  // Navigation entre les étapes
  // 1. Modifier la méthode nextStep() - PROBLÈME PRINCIPAL
nextStep() {
  if (this.currentStep === 0) {
    // Depuis la page d'accueil, on va à la sélection d'option
    this.currentStep = 1;
    setTimeout(() => window.scrollTo({ top: 500, behavior: 'smooth' }), 100);
    return;
  }
  
  if (this.isCurrentStepValid()) {
    // CORRECTION : Changer la condition de < 3 à < 4
    if (this.currentStep < 4) {  // ← CORRIGÉ : était < 3
      this.currentStep++;
      setTimeout(() => window.scrollTo({ top: 500, behavior: 'smooth' }), 100);
    }
  } else {
    this.markFormGroupTouched();
    this.toastr.warning("Veuillez remplir tous les champs obligatoires", "Attention");
  }
}

  previousStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      window.scrollTo(0, 0);
    }
  }

  // Sélection de l'option (Particulier/Entreprise)
  selectOption(option: string) {
    this.selectedOption = option;
    this.updateFormValidators();
    this.nextStep();
  }

  // Mise à jour des validateurs selon l'option choisie
  updateFormValidators() {
    if (this.selectedOption === 'Particulier') {
      this.simulationSanteForm.get('nom')?.setValidators([Validators.required]);
      this.simulationSanteForm.get('prenom')?.setValidators([Validators.required]);
      this.simulationSanteForm.get('dateNaiss')?.setValidators([Validators.required]);
      
      // Retirer les validateurs entreprise
      this.simulationSanteForm.get('nomEntreprise')?.clearValidators();
      this.simulationSanteForm.get('name')?.clearValidators();
      this.simulationSanteForm.get('service')?.clearValidators();
      
    } else if (this.selectedOption === 'Entreprise') {
      this.simulationSanteForm.get('nomEntreprise')?.setValidators([Validators.required]);
      this.simulationSanteForm.get('name')?.setValidators([Validators.required]);
      this.simulationSanteForm.get('service')?.setValidators([Validators.required]);
      
      // Retirer les validateurs particulier
      this.simulationSanteForm.get('nom')?.clearValidators();
      this.simulationSanteForm.get('prenom')?.clearValidators();
      this.simulationSanteForm.get('dateNaiss')?.clearValidators();
    }
    
    this.simulationSanteForm.updateValueAndValidity();
  }

 // 5. Modifier la validation de l'étape 3
isCurrentStepValid(): boolean {
  switch (this.currentStep) {
    case 0: // Page d'accueil
      return true;
      
    case 1: // Sélection option
      return this.selectedOption !== '';
      
    case 2: // Informations personnelles/entreprise
      if (this.selectedOption === 'Particulier') {
        return this.simulationSanteForm.get('nom')?.valid && 
               this.simulationSanteForm.get('prenom')?.valid &&
               this.simulationSanteForm.get('dateNaiss')?.valid &&
               this.simulationSanteForm.get('adresse')?.valid &&
               this.simulationSanteForm.get('email')?.valid &&
               this.simulationSanteForm.get('telephone')?.valid &&
               this.simulationSanteForm.get('taux')?.valid &&
               this.simulationSanteForm.get('territorialite')?.valid;
      } else {
        return this.simulationSanteForm.get('nomEntreprise')?.valid && 
               this.simulationSanteForm.get('name')?.valid &&
               this.simulationSanteForm.get('service')?.valid &&
               this.simulationSanteForm.get('adresse')?.valid &&
               this.simulationSanteForm.get('email')?.valid &&
               this.simulationSanteForm.get('telephone')?.valid &&
               this.simulationSanteForm.get('taux')?.valid &&
               this.simulationSanteForm.get('territorialite')?.valid;
      }
    
    case 3: // Garanties
      // CORRIGÉ : Vérifier qu'au moins une garantie est sélectionnée et que l'évacuation est renseignée
      const garanties = this.simulationSanteForm.get('type')?.value || [];
      const evacuation = this.simulationSanteForm.get('evacuation')?.value;
      return garanties.length > 0 && evacuation !== '';
    
    default:
      return true;
  }
}

  markFormGroupTouched() {
    Object.keys(this.simulationSanteForm.controls).forEach(key => {
      const control = this.simulationSanteForm.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
  }

  // Gestion du téléphone
  hasError(event: any, field: string, form: string) {
    this.hasPhoneError = !event;
  }

  getNumber(number: string, field: string, form: string) {
    this.simulationSanteForm.get(field)?.setValue(number);
  }

  telInputObject(obj: any) {
    // Gestion de l'objet téléphone
  }

  onCountryChange(country: any) {
    // Gestion du changement de pays pour le téléphone
  }

  // Gestion des fichiers
  selectOnFile(evt: any, type?: string, name?: string) {
    this.nomFile = name || 'Fichier sélectionné';
    this.loader = true;
    
    const accept = ['.doc', '.DOC', '.docx', '.DOCX', '.docm', '.DOCM', '.pdf', '.PDF', 
                   '.xls', '.XLS', '.xlsx', '.XLSX', '.png', '.PNG', '.jpg', '.JPG', '.jpeg', '.JPEG'];
    
    for (const file of evt.target.files) {  
      const index = file.name.lastIndexOf(".");
      const strsubstring = file.name.substring(index, file.name.length);
      let ext = strsubstring;
      
      if (accept.indexOf(strsubstring) === -1) {
        this.loader = false;
        this.toastr.error(`Ce fichier ${file.name} n'est pas au format autorisé`, 'Erreur');
        evt.target.value = '';
        return;
      } else {
        this.loader = true;
        const reader = new FileReader();
        
        reader.onload = (e: any) => {
          const docBase64Path = e.target.result;
          let image = '';
          
          if (ext === '.doc' || ext === '.DOC' || ext === '.docx' || ext === '.DOCX' || ext === '.docm' || ext === '.DOCM') {
            image = 'assets/images/doc.png';
            this.noImage = 'assets/images/doc.png';
          }
          else if (ext === '.pdf' || ext === '.PDF') {
            image = 'assets/images/pdf.png';
            this.noImage = 'assets/images/pdf.png';
          }
          else if (ext === '.xlsx' || ext === '.XLSX' || ext === '.xls' || ext === '.XLS') {
            image = 'assets/images/excel.png';
            this.noImage = 'assets/images/excel.png';
          }
          else {
            image = docBase64Path;
            this.noImage = docBase64Path;
          }
          this.saveFile1(file);
        };
        reader.readAsDataURL(file);
      }
    }
  }

  saveFile1(file: File) {
    this.loader = true;
    let dataFile = new FormData();
    dataFile.append('files', file);
    
    this.rechercheService.saveFile(dataFile).subscribe(
      resp => {
        if (resp) {
          this.loader = false;
          this.toastr.success("Fichier chargé avec succès", 'Succès');
          this.pieceJointe.get('file')?.setValue(resp['urlprod']);
        }
      }, 
      error => {
        this.loader = false;
        this.noImage = "assets/images/upload.png";
        this.nomFile = "";
        const errorMessage = error?.error?.errors?.[0]?.message || 
                            error?.error?.message || 
                            "Erreur lors du chargement du fichier";
        
        this.toastr.error(errorMessage, 'Erreur');
        this.pieceJointe.get('file')?.setValue('');
      }
    );
  }

  downloadModel() {
    if (this.typeProduitList?.questionnaireUrl) {
      window.open(this.typeProduitList.questionnaireUrl, '_blank');
    } else {
      window.open('/assets/fileDownload/questionnaire_sante.pdf', '_blank');
    }
    this.downloadFile = false;
  }

  // Sauvegarde
  // saveData() {
  //   this.sendingRequest = true;
  //   this.loader = true;
    
  //   const finalData = {
  //     ...this.simulationSanteForm.value,
  //     pieceJointe: this.pieceJointe.value,
  //     numeroSous: this.numeroSous,
  //     refPro: this.refPro,
  //     selectedOption: this.selectedOption
  //   };

  //   const submissionData = {
  //     designationClient: this.selectedOption === 'Particulier' 
  //       ? `${finalData.prenom} ${finalData.nom}` 
  //       : finalData.nomEntreprise,
  //     telephone: finalData.telephone,
  //     email: finalData.email,
  //     typeRisque: "SANTE",
  //     content: JSON.stringify(finalData)
  //   };
    
  //   this.rechercheService.saveSouscriptionOffline(submissionData)
  //     .subscribe(response => {
  //       if (response['responseCode'] == 200) {
  //         this.sendingRequest = false;
  //         this.loader = false;
  //         this.toastr.success("Demande de souscription enregistrée avec succès");
  //         this.currentStep = 4; // Étape succès
  //       } else {
  //         this.sendingRequest = false;
  //         this.loader = false;
  //         this.toastr.error(response['cause'].erreurs[0].message);
  //       }
  //     }, errors => {
  //       this.sendingRequest = false;
  //       this.loader = false;
  //       const errorMessage = errors['error']['cause'].erreurs ? 
  //         errors['error']['cause'].erreurs[0].message : 
  //         errors['error']['cause']['message'];
  //       this.toastr.error(errorMessage);
  //     });
  // }


  // 8. Modifier saveData pour gérer l'étape suivante
saveData() {
  this.sendingRequest = true;
  this.loader = true;
  
  const finalData = {
    ...this.simulationSanteForm.value,
    pieceJointe: this.pieceJointe.value,
    numeroSous: this.numeroSous,
    refPro: this.refPro,
    selectedOption: this.selectedOption
  };

  const submissionData = {
    designationClient: this.selectedOption === 'Particulier' 
      ? `${finalData.prenom} ${finalData.nom}` 
      : finalData.nomEntreprise,
    telephone: finalData.telephone,
    email: finalData.email,
    typeRisque: "SANTE",
    content: JSON.stringify(finalData)
  };
  
  this.rechercheService.saveSouscriptionOffline(submissionData)
    .subscribe(response => {
      if (response['responseCode'] == 200) {
        this.sendingRequest = false;
        this.loader = false;
        this.toastr.success("Demande de souscription enregistrée avec succès");
        this.currentStep = 5; // ← CORRIGÉ : était 4, maintenant 5 pour l'étape succès
      } else {
        this.sendingRequest = false;
        this.loader = false;
        this.toastr.error(response['cause'].erreurs[0].message);
      }
    }, errors => {
      this.sendingRequest = false;
      this.loader = false;
      const errorMessage = errors['error']['cause'].erreurs ? 
        errors['error']['cause'].erreurs[0].message : 
        errors['error']['cause']['message'];
      this.toastr.error(errorMessage);
    });
}

  resetForm() {
    this.currentStep = 0;
    this.selectedOption = '';
    this.simulationSanteForm.reset();
    this.pieceJointe.reset();
    this.nomFile = "";
    this.noImage = "assets/images/upload.png";
    window.scrollTo(0, 0);
  }

  getProgressPercentage(): number {
  const progressSteps = {
    0: 0,   // Page d'accueil
    1: 25,  // Sélection option
    2: 50,  // Informations
    3: 75,  // Garanties
    4: 100, // Récapitulatif
    5: 100  // Succès - AJOUTÉ
  };
  
  return progressSteps[this.currentStep] || 0;
}


 // 7. Corriger les textes de progression
getProgressText(): string {
  const progressTexts = {
    0: 'Bienvenue...',
    1: 'Choix du type...',
    2: 'Informations personnelles...',
    3: 'Choix des garanties...',
    4: 'Finalisation...',
    5: 'Terminé!' // AJOUTÉ
  };
  
  return progressTexts[this.currentStep] || 'Chargement en cours...';
}

  // autoSave() { 
  //   const finalData = {
  //     ...this.simulationSanteForm.value
  //   };
    
  //   let data = {
  //           "telephone": finalData.telephone,
  //           "email": finalData.email,
  //           "adresse": finalData.adresse,
  //           "type": " Assurance Sante",
  //           "displayName": this.selectedOption === 'Particulier' 
  //                           ? `${finalData.prenom} ${finalData.nom}` 
  //                           : finalData.nomEntreprise,
  //           "filiale": this.currentFiliale?.id,
  //           'prenom': finalData.prenom,
  //           'nom': finalData.nom,
  //   };
    
  //   this.rechercheService.autoSave(data)
  //     .subscribe(response => {
        
  //     }, errors => {
  //     });
  // }

  // ===== CONFIGURATION DE L'AUTOSAVE =====
  private setupAutoSave() {
    this.autoSaveSubscription = this.autoSaveSubject$.pipe(
      debounceTime(1000),
      distinctUntilChanged((prev, curr) => {
        return prev.email === curr.email && prev.telephone === curr.telephone;
      }),
      switchMap(data => {
        const currentDataString = JSON.stringify({
          email: data.email,
          telephone: data.telephone
        });
        
        if (currentDataString === this.lastSavedData) {
          return of(null);
        }
        
        this.lastSavedData = currentDataString;
        
        return this.rechercheService.autoSave(data).pipe(
          catchError(error => {
            return of(null);
          })
        );
      })
    ).subscribe(response => {
    });
  }

  // ===== MÉTHODE AUTOSAVE AMÉLIORÉE =====
  autoSave() {
    const formValue = this.simulationSanteForm?.value;
    if (!formValue) return;

    const hasValidEmail = formValue.email && this.emailPattern.test(formValue.email);
    
    const hasValidPhone = formValue.telephone && formValue.telephone.trim().length >= 8;

    if (!hasValidEmail && !hasValidPhone) {
      return;
    }

    if (!this.currentFiliale?.id) {
      return;
    }

    const displayName = this.selectedOption === 'Particulier' 
      ? `${formValue.prenom || ''} ${formValue.nom || ''}`.trim()
      : (formValue.nomEntreprise || '').trim();

    const data = {
      telephone: formValue.telephone?.trim() || '',
      email: formValue.email?.trim().toLowerCase() || '',
      adresse: formValue.adresse,
      type: "Assurance Sante",
      displayName: displayName || 'Non renseigné',
      filiale: this.currentFiliale.id,
      prenom: formValue.prenom,
      nom: formValue.nom
    };

    this.autoSaveSubject$.next(data);
  }
  // ========================================

   getDevisAutre() {
        this.currentStep = 0;
        setTimeout(() => {
            window.scrollTo({
                top: 600,
                behavior: 'smooth'
            });
        }, 100);
  }

}